import React, { useState, useEffect } from 'react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { Link, useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
const AddSubCategory = ({ onSuccess }) => {
  const [name, setName] = useState('');
  const [duration, setDuration] = useState('');
  const [price, setPrice] = useState('');
  const [categoryId, setCategoryId] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await DataService.getCategories();
      setCategories(response.data);
    } catch (error) {
      setError('Failed to fetch categories');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !duration || !price || !categoryId) {
      setError('All fields are required.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const payload = {
        name,
        service_duration: Number(duration),
        price:Number(price),
        category_id: Number(categoryId)
      };
      await DataService.addSubCategory(payload);
      setName('');
      setDuration('');
      setPrice('');
      setCategoryId('');
      navigate('/sub-categories')
      toast.success('Sub category added successfully.')
    } catch (err) {
      setError('Failed to add subcategory.');
    } finally {
      setLoading(false);
    }
  };
const goBack = () => navigate(-1); // navigate back to previous page

  return (
    <div >
      <LoaderOverlay loading={loading} />
      <h4>Add Subcategory</h4>

      <form onSubmit={handleSubmit} className="mt-3">
        <div className="mb-3">
          <label className="form-label">Subcategory Name</label>
          <input
            type="text"
            className="form-control  px-3"
            placeholder="Enter subcategory name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Select Category</label>
          <select
              className="form-control form-select custom-select-style"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
          >
            <option value="">Select Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Service Duration (in minutes)</label>
          <input
            type="number"
            className="form-control  px-3"
            placeholder="e.g. 30"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Price</label>
          <input
            type="number"
            className="form-control  px-3"
            placeholder="Enter price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary">
          Add Subcategory
        </button>
        <button className="btn btn-outline-secondary" style={{marginLeft:'15px'}} onClick={() => navigate(-1)}>
    ← Back
  </button>
      </form>
    </div>
  );
};

export default AddSubCategory;
